
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Emit } from 'vue-property-decorator';
import CPRadioGroup from '@/components/open-account/input/CPRadioGroup.vue';
import CPLoader from './CPLoader.vue';
import CPSubmitIndicator from './CPSubmitIndicator.vue';
import { CPRadio } from '@capital-platforms/cpui';
import { validate, formatValidationMessages } from '@/validation';
import {
  AppropriatenessTestSchema,
} from '@/store/appropriatenessTest/schema';

@Component({
    components: {
        CPRadioGroup,
        CPLoader,
        CPSubmitIndicator,
    },
    props: ['isCustomNeeded'],
})
export default class CPAppropriatenessTest extends Vue {
    public isCustomNeeded: boolean | false = this.$props.isCustomNeeded ?? false;
    public amountAnnualDisposable: string | null = null;
    public isSharesStructuredUCITS: boolean | false = false;
    public isSharesStructuredUCITS2: boolean | false = false;

    public isSharesNonUCITS: boolean | false = false;
    public isSharesNonUCITS2: boolean | false = false;

    public isStructuredProducts: boolean | false = false;
    public isStructuredProducts2: boolean | false = false;

    public isDeriativeProducts: boolean | false = false;
    public isDeriativeProducts2: boolean | false = false;

    public isOtherComplexProducts: boolean | false = false;
    public isOtherComplexProducts2: boolean | false = false;

    public isLessThan5: boolean | false = false;
    public isLessThan5_2: boolean | false = false;

    public isBetween5to10: boolean | false = false;
    public isBetween5to10_2: boolean | false = false;

    public isMoreThan10: boolean | false = false;
    public isMoreThan10_2: boolean | false = false;

    public isLessThan3000: boolean | false = false;
    public isLessThan5000: boolean | false = false;
    public isLessThan10000: boolean | false = false;
    public isMoreThan10000: boolean | false = false;
    public isOrderWithoutAdvisory: boolean | false = false;
    public isInvestmentAdvice: boolean | false = false;
    public isPortfolioManagement: boolean | false = false;

    public isLessThan3000_2: boolean | false = false;
    public isLessThan5000_2: boolean | false = false;
    public isLessThan10000_2: boolean | false = false;
    public isMoreThan10000_2: boolean | false = false;
    public isOrderWithoutAdvisory_2: boolean | false = false;
    public isInvestmentAdvice_2: boolean | false = false;
    public isPortfolioManagement_2: boolean | false = false;

    public remarks: string| null = '';
    public isSummaryInstructionOption: number | null = null;
    public isSummaryInstructionOptionI: boolean | false = false;
    public isSummaryInstructionOptionII: boolean | false = false;
    public isSummaryInstructionOptionIII: boolean | false = false;

    public isFormValidated: boolean | false = false;
    public activeMissingDocumentCategory = null;

    @Emit('add')
    public add(): void { /* add */ }


    public close() {
        this.$store.commit('toggleDocuSignModal', false);
    }

    public mounted() {
        this.$store.commit('setMissingDocumentIsSubmitted', false);

        if (this.$store.state.onlineDocs.onlineFormData.data != null) {
            this.remarks = this.$store.state.onlineDocs.onlineFormData.data.AppropriatenessTestRemarks;

            this.isSummaryInstructionOptionI = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSummaryInstructionOption;
            this.isSummaryInstructionOptionII = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSummaryInstructionOptionI;
            this.isSummaryInstructionOptionIII = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSummaryInstructionOptionII;
            if (this.isSummaryInstructionOptionI === true) {
                this.isSummaryInstructionOption = 1;
            }

            if (this.isSummaryInstructionOptionII === true) {
                this.isSummaryInstructionOption = 2;
            }

            if (this.isSummaryInstructionOptionIII === true) {
                this.isSummaryInstructionOption = 3;
            }

            this.isSharesStructuredUCITS = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSharesStructuredUCITS;
            this.isSharesStructuredUCITS2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSharesStructuredUCITS2;
            this.isSharesNonUCITS = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSharesNonUCITS;
            this.isSharesNonUCITS2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isSharesNonUCITS2;
            this.isStructuredProducts = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isStructuredProducts;
            this.isStructuredProducts2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isStructuredProducts2;
            this.isDeriativeProducts = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isDeriativeProducts;
            this.isDeriativeProducts2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isDeriativeProducts2;
            this.isOtherComplexProducts = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isOtherComplexProducts;
            this.isOtherComplexProducts2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isOtherComplexProducts2;
            this.isLessThan5 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan5;
            this.isLessThan5_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan5_2;
            this.isBetween5to10 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isBetween5to10;
            this.isBetween5to10_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isBetween5to10_2;
            this.isMoreThan10 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isMoreThan10;
            this.isMoreThan10_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isMoreThan10_2;
            this.isLessThan3000 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan3000;
            this.isLessThan5000 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan5000;
            this.isLessThan10000 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan10000;
            this.isMoreThan10000 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isMoreThan10000;
            this.isOrderWithoutAdvisory = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isOrderWithoutAdvisory;
            this.isOrderWithoutAdvisory_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isOrderWithoutAdvisory_2;
            this.isInvestmentAdvice = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isInvestmentAdvice;
            this.isInvestmentAdvice_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isInvestmentAdvice_2;
            this.isPortfolioManagement = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isPortfolioManagement;
            this.isPortfolioManagement_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isPortfolioManagement2;
            this.isLessThan3000_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan3000_2;
            this.isLessThan5000_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan5000_2;
            this.isLessThan10000_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isLessThan10000_2;
            this.isMoreThan10000_2 = this.$store.state.onlineDocs.onlineFormData.data.CheckBox_isMoreThan10000_2;

        }
        // this.$store.dispatch('getAlerts');
    }

    public onChangeIsSummaryInstructionOption() {

        switch (this.isSummaryInstructionOption) {
            case 1:
                this.isSummaryInstructionOptionI = true;
                this.isSummaryInstructionOptionII = false;
                this.isSummaryInstructionOptionIII = false;
                break;
            case 2:
                this.isSummaryInstructionOptionI = false;
                this.isSummaryInstructionOptionII = true;
                this.isSummaryInstructionOptionIII = false;
                break;
            case 3:
                this.isSummaryInstructionOptionI = false;
                this.isSummaryInstructionOptionII = false;
                this.isSummaryInstructionOptionIII = true;
                break;
        }

    }
    public async submit() {
      const docuSignFormData = {
            missingDocumentID: this.$store.state.missingDocument.ID,
            amountAnnualDisposable: this.amountAnnualDisposable,
            isSharesStructuredUCITS: this.isSharesStructuredUCITS,
            isSharesStructuredUCITS2: this.isSharesStructuredUCITS2,
            isSharesNonUCITS: this.isSharesNonUCITS,
            isSharesNonUCITS2: this.isSharesNonUCITS2,
            isStructuredProducts: this.isStructuredProducts,
            isStructuredProducts2: this.isStructuredProducts2,
            isDeriativeProducts: this.isDeriativeProducts,
            isDeriativeProducts2: this.isDeriativeProducts2,
            isOtherComplexProducts: this.isOtherComplexProducts,
            isOtherComplexProducts2: this.isOtherComplexProducts2,
            isLessThan5: this.isLessThan5,
            isLessThan5_2: this.isLessThan5_2,
            isBetween5to10: this.isBetween5to10,
            isBetween5to10_2: this.isBetween5to10_2,
            isMoreThan10: this.isMoreThan10,
            isMoreThan10_2: this.isMoreThan10_2,
            isLessThan3000: this.isLessThan3000,
            isLessThan5000: this.isLessThan5000,
            isLessThan10000: this.isLessThan10000,
            isMoreThan10000: this.isMoreThan10000,
            isOrderWithoutAdvisory: this.isOrderWithoutAdvisory,
            isOrderWithoutAdvisory_2: this.isOrderWithoutAdvisory_2,
            isInvestmentAdvice: this.isInvestmentAdvice,
            isInvestmentAdvice_2: this.isInvestmentAdvice_2,
            isPortfolioManagement: this.isPortfolioManagement,
            isPortfolioManagement_2: this.isPortfolioManagement_2,
            isLessThan3000_2: this.isLessThan3000_2,
            isLessThan5000_2: this.isLessThan5000_2,
            isLessThan10000_2: this.isLessThan10000_2,
            isMoreThan10000_2: this.isMoreThan10000_2,
            isFinancialChecked: (this.isSharesStructuredUCITS === true ||
            this.isSharesStructuredUCITS2 === true ||
            this.isSharesNonUCITS === true ||
            this.isSharesNonUCITS2 === true ||
            this.isStructuredProducts === true ||
            this.isStructuredProducts2 === true ||
            this.isDeriativeProducts === true ||
            this.isDeriativeProducts2 === true ||
            this.isOtherComplexProducts === true ||
            this.isOtherComplexProducts2 === true) ? true : false,
            isSummaryInstructionOption : this.isSummaryInstructionOption,
            isSummaryInstructionOptionI: this.isSummaryInstructionOptionI,
            isSummaryInstructionOptionII: this.isSummaryInstructionOptionII,
            isSummaryInstructionOptionIII: this.isSummaryInstructionOptionIII,
            remarks : this.remarks,
    };

      const validation = validate(
        docuSignFormData,
        AppropriatenessTestSchema,
    );

      if (validation.error) {
      const errArr: string[] = formatValidationMessages(
        validation.error.details,
      );
      this.$store.commit('addError',
        errArr[0]);
    } else {
        this.$store.commit('setMissingDocumentIsSubmitting', true);
        this.$store.commit('setMissingDocumentIsSubmitted', false);
        setTimeout(async () => {
            await this.$store.dispatch('submitDocusignDocument', {data: docuSignFormData, whiteLabelId: this.$store.state.account.details.whiteLabelId, isModalOpened: false});
            this.$store.commit('setMissingDocumentIsSubmitting', false);
            this.$store.commit('setMissingDocumentIsSubmitted', true);

            setTimeout(async () => {
                this.$store.commit('toggleDocuSignModal', false);

                setTimeout(async () => {
                    this.$store.commit('setMissingDocumentIsSubmitted', false);
                }, 300);
            }, 1000);

        }, 1000);

        }
    }



}
